import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: localStorage.getItem('cloud_state') ? JSON.parse(localStorage.getItem('cloud_state')) : {
    is_channel: false, // 是否在app内
  },
  mutations: {
    SET_ISCHANNEL: (state, is_channel) => {
      state.is_channel = is_channel
    }
  },
  actions: {
    set_is_channel ({commit}, is_channel) {
      commit('SET_ISCHANNEL', is_channel)
    }
  },
  modules: {
  },
  getters: {
    token: state => state.token,
    is_login: state => state.is_login,
  }
})
